export default "__VITE_ASSET__CbZLWwgg__"